// Один ПОСТОЯННЫЙ Suspense boundary над всеми экранами. react-router v7 оборачивает
// обновления состояния в React.startTransition, поэтому при переходе на незагруженный
// lazy-экран React удерживает предыдущий экран ЖИВЫМ (без ремоунта и без fallback),
// пока чанк не подгрузится — а сверху ползёт RouteProgressBar.
// Fallback с круглым лоадером показывается только при самой первой загрузке приложения.

import { RouteProgressBar } from '@web/components/route-progress'
import { RouteFallback } from '@web/router/fallback'
import { type ReactElement, Suspense, useCallback, useLayoutEffect, useState } from 'react'
import { useOutlet } from 'react-router-dom'

function RenderedOutlet({ children, onRendered }: { children: ReactElement; onRendered: () => void }) {
  useLayoutEffect(() => {
    onRendered()
  }, [onRendered])

  return children
}

export function RouteTransitionOutlet() {
  const outlet = useOutlet()
  const [hasRenderedOutlet, setHasRenderedOutlet] = useState(false)
  const markRendered = useCallback(() => setHasRenderedOutlet(true), [])

  if (!outlet) return null

  return (
    <>
      {hasRenderedOutlet && <RouteProgressBar />}
      <Suspense fallback={<RouteFallback />}>
        <RenderedOutlet onRendered={markRendered}>{outlet}</RenderedOutlet>
      </Suspense>
    </>
  )
}
